import { MoneyConnectClientAPI } from "./axios-service-creator";

export const HistoryAPI = {
  Primary: {
    getHistory: (params) => MoneyConnectClientAPI.get("/subscription/security/histories", { params }),
    getHistoryDetail: (params) => MoneyConnectClientAPI.get("/subscription/security/histories/detail", { params }),
    editSubscriptionInfo: (payload) =>
      MoneyConnectClientAPI.post("/subscription/security/histories/receive/change", payload),
    resendEmail: (payload) => MoneyConnectClientAPI.post("/subscription/security/histories/resend/email", payload),
    cancelTransaction: (payload) =>
      MoneyConnectClientAPI.post("/subscription/security/histories/client/cancel/confirmation", payload),
  },
  Secondary: {
    getHistory: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/history", payload),
    getHistoryDetail: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/historyDetail", payload),
    resendEmail: (payload) => MoneyConnectClientAPI.post("/digitalbond/sendEmail/confirmTrans", payload),
  },
  WithholdingTax: {
    getWithholdingTaxList: (payload) =>
      MoneyConnectClientAPI.post("/digitalbond/history/getWithholdingTaxList", payload),
    sendEmail: (payload) => MoneyConnectClientAPI.post("/digitalbond/history/sendEmailWithholdingTaxHist", payload),
  },
  StructureNote: {
    getHistory: (params) => MoneyConnectClientAPI.get("/subscription/security/structureNote/histories", { params }),
    getHistoryDetail: (params) =>
      MoneyConnectClientAPI.get("/subscription/security/structureNote/histories/detail", { params }),
    editSubscriptionInfo: (payload) =>
      MoneyConnectClientAPI.post("/subscription/security/structureNote/histories/receive/change", payload),
    resendEmail: (payload) =>
      MoneyConnectClientAPI.post("/subscription/security/structureNote/histories/resend/email", payload),
    cancelTransaction: (payload) =>
      MoneyConnectClientAPI.post("/subscription/security/histories/client/cancel/confirmation", payload),
  },
};
